<template>
  <div>
    <v-row>
      <v-col class="pr-0 pr-sm-2">
        <BaseFormSelect
          id-element="insuranceTypeQuotation"
          placeholder="Escolher"
          label-text="Tipo de Seguro"
          v-model="editForm.tipo_seguro"
          :items="insuranceType"
          item-text="nome"
          item-value="id"
          required
          :rules="[requiredInput]"
          :return-object="true"
          :readonly="readonly"
        />
      </v-col>
      <v-col class="pr-sm-2">
        <BaseFormSelect
          id-element="insuranceCompanyQuotation"
          placeholder="Escolher"
          label-text="Seguradora"
          v-model="editForm.seguradora"
          :items="insuranceCompanyOptions"
          item-text="nome"
          item-value="codigo"
          required
          :rules="[requiredInput]"
          :return-object="true"
          :readonly="readonly"
        />
      </v-col>
      <v-col class="pr-0 pr-sm-2">
        <BaseMoney
          id-element="insuredAreaQuotation"
          placeholder="0,00"
          label-text="Área (ha)"
          v-model="editForm.area_segurada"
          required
          :rules="[requiredInput, aboveZero]"
          :money="typeDecimal"
          :readonly="readonly"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pr-0 pr-sm-2">
        <BaseFormSelect
          id-element="claimTypeQuotation"
          placeholder="Escolher"
          label-text="Regulação Sinistro"
          v-model="editForm.tipo_reivindicacao"
          :items="claimType"
          item-text="nome"
          item-value="id"
          required
          :rules="[requiredInput]"
          :return-object="true"
          :readonly="readonly"
        />
      </v-col>
      <v-col class="pr-0 pr-sm-2">
        <BaseFormSelect
          id-element="coverageQuotation"
          placeholder="Escolher"
          label-text="Coberturas"
          v-model="editForm.tipo_cobertura"
          :items="coverage"
          item-text="nome"
          item-value="id"
          required
          :rules="[requiredInput]"
          :return-object="true"
          :readonly="readonly"
        />
      </v-col>
    </v-row>
    <v-row class="mb-8">
      <v-col class="pr-0 pr-sm-2">
        <BaseMoney
          id-element="insuredValueQuotation"
          placeholder="0,00"
          label-text="Importância Segurada"
          v-model="editForm.importancia_segurada"
          required
          :rules="[requiredInput, aboveZero]"
          :readonly="readonly"
        />
      </v-col>
      <v-col class="pr-0 pr-sm-2">
        <BaseMoney
          id-element="grantedProductionQuotation"
          placeholder="0,00"
          label-text="Produtividade Garantida"
          v-model="editForm.producao_garantida"
          required
          :rules="[requiredInput, aboveZero]"
          :money="typeDecimal"
          :readonly="readonly"
        />
      </v-col>
      <v-col v-if="isInsuranceTypeProductivity" class="pr-0 pr-sm-2">
        <BaseMoney
          id-element="costPerSacQuotation"
          placeholder="0,00"
          label-text="Preço da Saca"
          v-model="editForm.custo_por_saca"
          required
          :rules="[requiredInput, aboveZero]"
          :readonly="readonly"
        />
      </v-col>
      <v-col v-if="!isInsuranceTypeProductivity" class="pr-0 pr-sm-2">
        <BaseMoney
          id-element="costPerSacQuotation"
          placeholder="0,00"
          label-text="Valor por Hectare (R$)"
          v-model="editForm.custo_por_hectare"
          required
          :rules="[requiredInput, aboveZero]"
          :readonly="readonly"
        />
      </v-col>
      <v-col class="pr-0 pr-sm-2">
        <BaseMoney
          id-element="totalQuotation"
          placeholder="0,00"
          label-text="Preço Total"
          v-model="editForm.custo_total"
          required
          :rules="[requiredInput, aboveZero]"
          :readonly="readonly"
        />
      </v-col>
    </v-row>
    <v-row class="mb-2">
      <v-col class="pr-0 pr-sm-2">
        <BaseMoney
          id-element="federalSubventionQuotation"
          placeholder="0,00"
          label-text="Subvenção Federal"
          v-model="editForm.subvencao_federal"
          required
          :rules="[requiredInput, aboveZero]"
          :readonly="readonly"
        />
      </v-col>
      <v-col class="pr-0 pr-sm-2">
        <BaseMoney
          id-element="stateSubventionQuotation"
          placeholder="0,00"
          label-text="Subvenção Estadual"
          v-model="editForm.subvencao_estadual"
          required
          :rules="[requiredInput, aboveZero]"
          :readonly="readonly"
        />
      </v-col>
      <v-col class="pr-0 pr-sm-2">
        <BaseMoney
          id-element="insuredPriceQuotation"
          placeholder="0,00"
          label-text="Preço do Segurado"
          v-model="editForm.custo_segurado"
          required
          :rules="[requiredInput, aboveZero]"
          :readonly="readonly"
        />
      </v-col>
      <v-col class="pr-0 pr-sm-2">
        <BaseMoney
          id-element="farmerPriceQuotation"
          placeholder="0,00"
          label-text="Preço do produtor (R$/ha)"
          v-model="editForm.custo_produtor"
          required
          :rules="[requiredInput, aboveZero]"
          :readonly="readonly"
        />
      </v-col>
      <v-col class="pr-0 pr-sm-2">
        <BaseFormSelect
          id-element="paymentFormQuotation"
          placeholder="Escolher"
          label-text="Forma de Pagamento"
          v-model="editForm.forma_pagamento"
          :items="paymentForm"
          item-text="nome"
          item-value="id"
          required
          :rules="[requiredInput]"
          :return-object="true"
          :disabled="false"
          :readonly="readonly"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { requiredInput, aboveZero } from "@/utils/rules.js";
import DocumentsMixin from "@/mixins/DocumentsMixin";

const INSURANCE_TYPE = [
  {
    id: "produtividade",
    nome: "Produtividade"
  },
  {
    id: "custeio",
    nome: "Custeio"
  }
];
const CLAIM_TYPE = [
  {
    id: "media_area",
    nome: "Média da área atual"
  },
  {
    id: "talhao",
    nome: "Talhão"
  }
];
const COVERAGE_TYPE = [
  {
    id: "basica",
    nome: "Básica"
  },
  {
    id: "basica_replantio",
    nome: "Básica + Replantio"
  }
];
const PAYMENT_FORM = [
  {
    id: "1",
    nome: "À Vista"
  },
  {
    id: "2",
    nome: "2 Parcelas"
  },
  {
    id: "3",
    nome: "3 Parcelas"
  },
  {
    id: "4",
    nome: "4 Parcelas"
  },
  {
    id: "5",
    nome: "5 Parcelas"
  }
];

const typeDecimal = {
  decimal: ",",
  thousands: ".",
  prefix: "",
  suffix: "",
  precision: 2,
  masked: false
};

export default {
  name: "QuotationProposalAgricola",
  mixins: [DocumentsMixin],
  data() {
    return {
      insuranceType: INSURANCE_TYPE,
      claimType: CLAIM_TYPE,
      coverage: COVERAGE_TYPE,
      paymentForm: PAYMENT_FORM,
      typeDecimal,
      aboveZero,
      requiredInput
    };
  },
  created() {
    this.loadOptions();
  },
  computed: {
    ...mapState("quotation", ["insuranceCompanyOptions"]),
    isInsuranceTypeProductivity() {
      return this.editForm.tipo_seguro?.id == "produtividade";
    }
  },
  methods: {
    ...mapActions("quotation", ["fetchInsuranceCompany"]),
    loadOptions() {
      if (
        this.insuranceCompanyOptions == null ||
        this.insuranceCompanyOptions.length == 0
      ) {
        let payload = {
          somenteAtivos: true,
          modalidade: 'agricola'
        };
        this.withLoading(this.fetchInsuranceCompany(payload));
      }
    }
  },
  props: {
    editForm: {
      type: Object
    },
    readonly: {
      type: Boolean,
      default: false
    }
  }
};
</script>
